export const UserControllerFactory = ({
  userService,
}: {
  userService: IUserService;
}) => {
  const getUserBetaFeatures: IGetUserBetaFeaturesController = async () => {
    const userBetaFeature = await userService.getUserBetaFeatures();
    return userBetaFeature;
  };

  const updateUserInfo: IUpdateUserInfoController = async (payload) => {
    const userInfo = await userService.updateUserInfo(payload);
    return userInfo;
  };

  const signupUser: ISignupUserController = async (payload) => {
    const user = await userService.signupUser(payload);
    return user;
  };

  const getAdminPendingUsers: IGetAdminPendingUsers = async (payload) =>
    userService.getAdminPendingUsers(payload);

  const activateAdminPendingUser: IActivateAdminPendingUser = async (payload) =>
    userService.activateAdminPendingUser(payload);

  const resendUserInvite: IResendUserInvite = async (payload) =>
    userService.resendUserInvite(payload);

  const getClinicUsers: IGetClinicUsers = async (payload) =>
    userService.getClinicUsers(payload);

  return {
    getUserBetaFeatures,
    updateUserInfo,
    signupUser,
    getAdminPendingUsers,
    activateAdminPendingUser,
    resendUserInvite,
    getClinicUsers,
  };
};
